export enum ProductsBiocatchEnum {
    AHO = 'AHO',
    NOM = 'NOM',
    TCR = 'TCR',
    ORD = 'ORD',
    CRP = 'CRP',
    VIV = 'VIV',
    LOA = 'LIB',
}

export enum StepBiocatchEnum {
    productos = 'productos',
    solicitud = 'solicitud',
    identificacion = 'identificacion',
    captura = 'captura',
    configuracion = 'configuracion',
    vinculacion = 'vinculacion',
    oferta = 'oferta',
    simulacion = 'simulacion',
    service_up = 'Si_Geo_Biocatch',
    service_down = 'No_Geo_Biocatch',
}

export enum StepBiocatchEnumFirmlyApproved {
    solicitud_aprobado_firme = 'SolAprobadosFirme',
}
